import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

// __SUPABASE_URL__, __SUPABASE_KEY__, __DEMO_MODE__ are replaced at build time
// by the `define` block in vite.config.ts. They come from system environment
// variables (process.env), so a local .env file with wrong/placeholder values
// cannot accidentally override them. This keeps the production build working on
// Dondominio (no .env file) and in CI, without any manual setup.
declare const __SUPABASE_URL__: string
declare const __SUPABASE_KEY__: string
declare const __DEMO_MODE__: string

const supabaseUrl = __SUPABASE_URL__
const supabaseKey = __SUPABASE_KEY__

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken:    true,
    persistSession:      true,
    detectSessionInUrl:  true,
    storageKey:          'navabuena-epc-auth',
  },
  global: {
    headers: {
      'x-application-name': 'navabuena-epc-tracker',
    },
  },
  db: {
    schema: 'public',
  },
})

// Demo mode is ONLY active when explicitly set via system env var VITE_DEMO_MODE=true
// (a local .env file with VITE_DEMO_MODE=true does NOT affect this value)
export const isDemoMode =
  __DEMO_MODE__ === 'true' ||
  supabaseUrl === 'https://placeholder.supabase.co'

export type SupabaseClient = typeof supabase
